import type { ComponentMap } from '@fondof-ui/components/content-builder/types'

import { trackError } from '@fond-of/telemetry'

export interface RendererProps {
  __typename: string
  sys: {
    id: string
  }
}

// Define the type for a Vue component.
// `ReturnType<typeof defineComponent>` is a good way to get the type
// of a component defined with `defineComponent` or a typical SFC import.

/**
 * Dynamically retrieves a component from the componentMap based on __typename.
 *
 * @param props The content props containing __typename and sys.id.
 * @param componentMap An object mapping __typename strings to Vue component references.
 * @returns The Vue component reference, or null if not found or invalid input.
 */
export const renderer = (
  { __typename, ...args }: RendererProps,
  componentMap: ComponentMap
) => {
  if (!__typename || !args.sys.id) {
    trackError('Either __typename or id not found!')
    return null
  }

  const ComponentToRender = componentMap[__typename]

  if (!ComponentToRender) {
    trackError(`Missing component for type: ${__typename}`)
    return null
  }

  return ComponentToRender
}
